import React from "react";
import { Grid, Link } from "@mui/material";
import { BodyTypography, HeaderTypography } from "./Typography";

const Impressum = () => {
  return (
    <Grid container flexDirection="column" alignContent="flex-start">
      <HeaderTypography>
        Anbieterkennzeichnung nach dem Telemediengesetz (TMG)
      </HeaderTypography>
      <HeaderTypography>Betreiber der Webpräsenz Tillystraße</HeaderTypography>
      <BodyTypography typographyProps={{ sx: { mb: 1 } }}>
        TÜV Rheinland Consulting GmbH <br />
        Tillystraße 2<br />
        90431 Nürnberg
        <br />
        Tel. +49 221 806 1950
        <br />
        Fax +49 221 806 3496
        <br />
        E-Mail:{" "}
        <Link href="mailto:consulting@de.tuv.com">consulting@de.tuv.com</Link>
      </BodyTypography>
      <HeaderTypography>Geschäftsführung</HeaderTypography>
      <BodyTypography typographyProps={{ sx: { mb: 1 } }}>
        Mariusz C. Bodek <br /> Gunnar Franke
      </BodyTypography>
      <HeaderTypography>Handelsregister</HeaderTypography>
      <BodyTypography typographyProps={{ sx: { mb: 1 } }}>
        Registernummer HRB 27242, Amtsgericht Nürnberg
      </BodyTypography>
      <HeaderTypography>
        Umsatzsteueridentifikationsnr. (USt-IdNr.)
      </HeaderTypography>
      <BodyTypography typographyProps={{ sx: { mb: 1 } }}>
        DE 123060706
      </BodyTypography>
      <HeaderTypography>
        Verantwortlicher gemäß § 55 Abs. 2 RStV
      </HeaderTypography>
      <BodyTypography typographyProps={{ sx: { mb: 1 } }}>
        TÜV Rheinland Consulting GmbH
      </BodyTypography>
      <HeaderTypography>
        Leitung Marketing und Unternehmenskommunikation
      </HeaderTypography>
      <BodyTypography>Tobias Kirchhoff</BodyTypography>
    </Grid>
  );
};

export default Impressum;
